<main
  class="min-h-screen bg-neutral px-6 py-10 flex items-center justify-center text-center"
>
  <section class="flex w-full max-w-2xl flex-col items-center">
    <app-logo
      class="w-[13rem] text-kek-purple"
      [clickable]="false"
    ></app-logo>

    <h1 class="-mt-4 text-[2.5rem] text-inverted-neutral space-grotesk-600">
      Thank you
    </h1>

    <p class="mt-3 max-w-xl text-[1.25rem] text-support-text inter-400">
      You have completed this questionnaire. We appreciate your participation.
    </p>
  </section>
</main>
